import { createContext } from 'react'

export const Patron = createContext(null)
